import Vue from 'vue'
import {MessageBox} from 'element-ui'
import $l1 from '../../static/languages/chs.json'
import $l2 from '../../static/languages/en.json'
import $l3 from '../../static/languages/ja.json'

var loading = '';
var setTime = '';
var setTimes = [];
var loadings = [];
export default {
  startLoading() {
    loading = Vue.prototype.$loading({
      lock: true,
      text: "Loading...",
      target: document.querySelector('.main-content') //设置加载动画区域
    });
    loadings.push(loading);
  },
  endLoading() {
    // if(loadings.length > 0){
    //   loadings.forEach(function (item) {
    //     item.close();
    //   });
    //   loadings = [];
    // }
	loading.close();
	loadings.forEach(e=> e.close());
  },
	isEmptyObject(obj) {
		for (let key in obj) {
			return false
		};
		return true
	},
	isEmpty(p){
			if (p == null || p == undefined || p == '') {
			  return true;
			}
			return false;
	},
	messageAlert(msg, title, btn) {
		// MessageBox(msg, title, {
		// 	confirmButtonText: btn
		// });
		Vue.prototype.$message({
			message: msg,
			type: 'error'
		});
	},
	tipsAlert(msg) {
		// MessageBox(msg, "提示", {
		// 	confirmButtonText: '确定'
		// });
		var language = {};
		if(localStorage.getItem("LoginLanguage") == "chs" || localStorage.getItem("LoginLanguage") == ''||localStorage.getItem("LoginLanguage") == null){
		  language = $l1;
		}
		if(localStorage.getItem("LoginLanguage") == "en"){
		  language = $l2;
		}
		if(localStorage.getItem("LoginLanguage") == "ja"){
		  language = $l3;
		}
		Vue.prototype.$message({
			message: msg,
			type: 'success'
		});
	},
	saveAlert() {
		var language = {};
		if(localStorage.getItem("LoginLanguage") == "chs" || localStorage.getItem("LoginLanguage") == '' ||localStorage.getItem("LoginLanguage") == null){
		  language = $l1;
		}
		if(localStorage.getItem("LoginLanguage") == "en"){
		  language = $l2;
		}
		if(localStorage.getItem("LoginLanguage") == "ja"){
		  language = $l3;
		}
		// MessageBox("保存成功", "提示", {
		// 	confirmButtonText: '确定'
		// });
	},
	editAlert() {
		var language = {};
		  if(localStorage.getItem("LoginLanguage") == "chs" || localStorage.getItem("LoginLanguage") == ''||localStorage.getItem("LoginLanguage") == null){
		    language = $l1;
		  }
		  if(localStorage.getItem("LoginLanguage") == "en"){
		    language = $l2;
		  }
		  if(localStorage.getItem("LoginLanguage") == "ja"){
		    language = $l3;
		  }
		// 修改成功   提示
		  MessageBox(language.common.tip4, language.common.tips, {
		    confirmButtonText: language.common.determine
		  });
		// MessageBox("修改成功", "提示", {
		// 	confirmButtonText: '确定'
		// });
	},
	delAlert() {
		var language = {};
		  if(localStorage.getItem("LoginLanguage") == "chs" || localStorage.getItem("LoginLanguage") == ''||localStorage.getItem("LoginLanguage") == null){
		    language = $l1;
		  }
		  if(localStorage.getItem("LoginLanguage") == "en"){
		    language = $l2;
		  }
		  if(localStorage.getItem("LoginLanguage") == "ja"){
		    language = $l3;
		  }
		// 删除成功   提示
		  MessageBox(language.common.tip5, language.common.tips, {
		    confirmButtonText: language.common.determine
		  });
		// MessageBox("删除成功", "提示", {
		// 	confirmButtonText: '确定'
		// });
	},
	urlSplit(list) {
	  let urlMsg = "";
	  for (let key in list) {
	   if(list[key] != '' && list[key] != null && list[key] != undefined){
	    urlMsg += key + "=" + list[key] + "&";
	   }
	  };
	  return urlMsg.substr(0, urlMsg.length - 1);
	 },
	isValidIP(ip) {
		let reg =
			/^(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$/
		return reg.test(ip);
	},
  getNowFormatDate() {
    let date = new Date();
    let seperator1 = "-";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    let strHour = date.getHours();
    let strMin = date.getMinutes();
    let strSec = date.getSeconds();
    if (strHour >= 0 && strHour <= 9) {
      strHour = "0" + strHour;
    }
    if (strMin >= 0 && strMin <= 9) {
      strMin = "0" + strMin;
    }
    if (strSec >= 0 && strSec <= 9) {
      strSec = "0" + strSec;
    }
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate+' '+strHour+":"+strMin+":"+strSec;
    return currentdate;
  },
    getPreMonthFormatDate() {
        let date = new Date();
        let seperator1 = "-";
        let year = date.getFullYear();
        let month = date.getMonth();
        let strDate = date.getDate();
        let strHour = date.getHours();
        let strMin = date.getMinutes();
        let strSec = date.getSeconds();
        if (strHour >= 0 && strHour <= 9) {
            strHour = "0" + strHour;
        }
        if (strMin >= 0 && strMin <= 9) {
            strMin = "0" + strMin;
        }
        if (strSec >= 0 && strSec <= 9) {
            strSec = "0" + strSec;
        }
        if (month >= 1 && month <= 9) {
            month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
            strDate = "0" + strDate;
        }
        let currentdate = year + seperator1 + month + seperator1 + strDate+' '+strHour+":"+strMin+":"+strSec;
        return currentdate;
    },
  getTimePreHour() {
    let date = new Date(new Date().getTime() - 3600000);
    let seperator1 = "-";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    let strHour = date.getHours();
    let strMin = date.getMinutes();
    let strSec = date.getSeconds();
    if (strHour >= 0 && strHour <= 9) {
      strHour = "0" + strHour;
    }
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate+' '+strHour+":00:00";
    return currentdate;
  },
	getTimeNowHour() {
	  let date = new Date();
	  let seperator1 = "-";
	  let year = date.getFullYear();
	  let month = date.getMonth() + 1;
	  let strDate = date.getDate();
	  let strHour = date.getHours();
	  if (strHour >= 0 && strHour <= 9) {
	    strHour = "0" + strHour;
	  }
	  if (month >= 1 && month <= 9) {
	    month = "0" + month;
	  }
	  if (strDate >= 0 && strDate <= 9) {
	    strDate = "0" + strDate;
	  }
	  let currentdate = year + seperator1 + month + seperator1 + strDate+' '+strHour+":00:00";
	  return currentdate;
	},
  getPreFormatDate() {
    let date = new Date();
    let seperator1 = "-";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate()-1;
    let strHour = date.getHours();
    let strMin = date.getMinutes();
    let strSec = date.getSeconds();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    if (strHour >= 0 && strHour <= 9) {
      strHour = "0" + strHour;
    }
    if (strMin >= 0 && strMin <= 9) {
      strMin = "0" + strMin;
    }
    if (strSec >= 0 && strSec <= 9) {
      strSec = "0" + strSec;
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate+' '+strHour+":"+strMin+":"+strSec;
    return currentdate;
  },
  getDayFormatDate() {
    let date = new Date();
    let seperator1 = "-";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month + seperator1 + strDate;
    return currentdate;
  },
  getDayFormatDateWithoutSeperator() {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    return '' + year + month + strDate;
  },
  getMonthFormatDate() {
    let date = new Date();
    let seperator1 = "-";
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let strDate = date.getDate();
    if (month >= 1 && month <= 9) {
      month = "0" + month;
    }
    if (strDate >= 0 && strDate <= 9) {
      strDate = "0" + strDate;
    }
    let currentdate = year + seperator1 + month;
    return currentdate;
  },
  timing(fun, millisecond) {
    setTime = setInterval(() => {
      fun();
    }, millisecond);
    setTimes.push(setTime);
  },
  clearTime(){
    setTimes.forEach(function (item) {
      clearInterval(item);
    });
    setTimes = [];
  },
}



// WEBPACK FOOTER //
// ./src/utils/utils.js